import { jsx as e } from "react/jsx-runtime";
import i from "react";
const m = i.forwardRef(
  ({
    name: r,
    width: s = "20px",
    height: o = "20px",
    className: t,
    color: n
  }, a) => /* @__PURE__ */ e(
    "svg",
    {
      width: s,
      height: o,
      "aria-label": `${r} icon`,
      className: t,
      role: "img",
      ref: a,
      color: n,
      children: /* @__PURE__ */ e("use", { href: `/Content/Vendor/icons/sprite.svg#${r}` })
    }
  )
);
function c(r) {
  var s, o, t = "";
  if (typeof r == "string" || typeof r == "number") t += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var n = r.length;
    for (s = 0; s < n; s++) r[s] && (o = c(r[s])) && (t && (t += " "), t += o);
  } else for (o in r) r[o] && (t && (t += " "), t += o);
  return t;
}
function f() {
  for (var r, s, o = 0, t = "", n = arguments.length; o < n; o++) (r = arguments[o]) && (s = c(r)) && (t && (t += " "), t += s);
  return t;
}
const l = "elo-section", u = {
  section: l
}, y = i.forwardRef(
  ({ children: r, className: s, as: o = "section", ...t }, n) => /* @__PURE__ */ e(
    o,
    {
      ...t,
      ref: n,
      className: f(u.section, s),
      children: r
    }
  )
);
export {
  m as I,
  y as S,
  f as c
};
